export default (inverters) => {
    return inverters.sort((inverter1, inverter2) => {
        let id1 = inverter1.id;
        let id2 = inverter2.id;
        let systemid1 = inverter1.systemId;
        let systemid2 = inverter2.systemId;
        if(id1<id2)
            return -1;
        if(id1>id2)
            return 1;
        if(systemid1<systemid2)
            return -1;
        return 1;
    });
}


// WEBPACK FOOTER //
// ./src/selectors/inverters.js